/** A combined quote already covers every requested occupancy, including its stock gate. */
export function isFlashSameRoomPackageAvailable(view: App.OfferPackageOptionView, roomCount: number, requiresRates: boolean, checkInventory: boolean): boolean {
  return roomCount > 0 && view.capacityValid && view.hotelAvailable && (!requiresRates || !!view.hasAvailableRates) &&
    (!checkInventory || (view.availableRooms !== undefined && view.availableRooms >= roomCount))
}

/** Semantic quote identity for login and editable purchase-flow continuations. */
export function getFlashPackageQuoteContext(view: App.OfferPackageOptionView | undefined) {
  return view && [
    view.package.uniqueKey, view.package.roomRate.id, view.pricing, view.memberPricing,
    view.hotelPrice, view.hotelMemberPrice, view.hotelTotal, view.hotelMemberTotal,
    view.propertyFees, view.taxesAndFees, view.availableRooms, view.capacityValid,
    view.hotelAvailable, view.hasAvailableRates, view.package.allowBuyNowBookLater,
    view.package.roomRate.cancellationPolicy, view.package.roomRate.cancellationPolicies,
  ]
}

/** Existing Flash restriction: three or more rooms with redeemable member pricing need an agent. */
export function requiresFlashMultiRoomAssistance({ roomCount, canRedeemLuxPlusBenefits, hotelMemberTotal }: {
  roomCount: number
  canRedeemLuxPlusBenefits: boolean
  hotelMemberTotal: number
}): boolean {
  return roomCount > 2 && canRedeemLuxPlusBenefits && hotelMemberTotal > 0
}
